module.exports = __webpack_public_path__ + "static/media/integral_card_2.a4c9ef93.png";